<template>
  <section class="email-confirmation-page app-content d-flex align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-4 email-confirmation-container text-center">
          <img class="email-logo" src="~assets/img/email.png">
          <img class="email-bitte-logo mt-2" src="~assets/img/email-bitte.png">
          <p class="mt-4">Um Ihre Registrierung abzuschließen, bestätigen Sie bitte Ihre E-Mail Adresse.</p>
          <button @click="checkValidation()" class="btn-submit mt-1" >
            Registrierungsstatus überprüfen
          </button>
          <button @click="showModalMessage = false" v-b-modal.confirmation-modal class="d-inline-block underlined-link mt-3"><u>Aktivierungs E-Mail nicht bekommen?</u></button>
          <b-modal ref="confirmationModal" size="sm" id="confirmation-modal" centered class="app-modals" hide-footer>
            <button v-if="!showModalMessage" @click="sendAgain()" class="btn btn-neue w-100 my-1">E-Mail nochmals zusenden</button>
            <button v-if="!showModalMessage" @click="cancelRegistration()" class="btn btn-neue w-100 my-1">Registrierung verwerfen</button>
            <div v-if="showModalMessage" class="text-center pb-4">
              {{ modalMessage }}
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// API
import accountApi from '@/api/v1/account';
import pinboardApi from '@/api/v1/pinboard';

export default {
  data() {
    return {
      showModalMessage: false,
      modalMessage: '',
    };
  },
  methods: {
    checkValidation() {
      pinboardApi.index((data) => {
        if (data.statuscode === 200) {
          accountApi.show((resp) => {
            const name = `${resp.detailresponse.firstname} ${resp.detailresponse.lastname}`;
            localStorage.setItem('User-Confirmed', resp.detailresponse.validated);
            localStorage.setItem('User-Name', name);

            accountApi.setDefaultPinboard(() => { location.href = ''; });
          });
        } else {
          this.modalMessage = 'E-Mail Adresse wurde noch nicht bestätigt.';
          this.showModalMessage = true;
          this.$refs.confirmationModal.show();
        }
      });
    },
    sendAgain() {
      accountApi.resendEmail(() => {
        this.modalMessage =
          'Eine E-Mail zur Bestätigung Ihrer Adresse wurde an die angegebene E-Mail Adresse versandt.';
        this.showModalMessage = true;
        setTimeout(() => {
          this.$refs.confirmationModal.hide();
        }, 1000);
      });
    },
    cancelRegistration() {
      accountApi.cancelRegistration(() => {
        this.modalMessage = 'Registrierung wurde abgebrochen. Ihr Daten wurden gelöscht. ';
        this.showModalMessage = true;
        location.href = '';
        setTimeout(() => {
          this.$refs.confirmationModal.hide();
        }, 1000);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Auth/EmailConfirmation.vue